var map = {
	"./boccia01.jpg": 8664,
	"./boccia02.jpg": 9284,
	"./boccia03.jpg": 7158,
	"./boccia04.jpg": 4724,
	"./boccia05.jpg": 8402,
	"./boccia06.jpg": 7493,
	"./boccia07.jpg": 1185,
	"./boccia08.jpg": 306,
	"./boccia09.jpg": 1400,
	"./boccia10.jpg": 6483,
	"assets/photo/reportage/boccia/boccia01.jpg": 8664,
	"assets/photo/reportage/boccia/boccia02.jpg": 9284,
	"assets/photo/reportage/boccia/boccia03.jpg": 7158,
	"assets/photo/reportage/boccia/boccia04.jpg": 4724,
	"assets/photo/reportage/boccia/boccia05.jpg": 8402,
	"assets/photo/reportage/boccia/boccia06.jpg": 7493,
	"assets/photo/reportage/boccia/boccia07.jpg": 1185,
	"assets/photo/reportage/boccia/boccia08.jpg": 306,
	"assets/photo/reportage/boccia/boccia09.jpg": 1400,
	"assets/photo/reportage/boccia/boccia10.jpg": 6483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9029;